import { FC, memo, useMemo } from "react";
import styles from "./UpvoteButton.module.css";

import { Button } from "components/Button";
import { ButtonProps } from "antd";
import { useMutation, useQueryClient } from "react-query";
import {
  likeProjectRequest,
  dislikeProjectRequest,
  IProject,
} from "api/project";
import { useUser } from "api/auth";
import clsx from "clsx";

type UpvoteButtonProps = Partial<ButtonProps> & {
  project: IProject;
  className?: string;
};

const UpvoteButton: FC<UpvoteButtonProps> = ({ project, className }) => {
  const queryClient = useQueryClient();
  const { data: me } = useUser({ enabled: false });
  const { mutate: like } = useMutation(likeProjectRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries(["project", project._id]);
    },
  });
  const { mutate: dislike } = useMutation(dislikeProjectRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries(["project", project._id]);
    },
  });

  const isLiked = useMemo(() => {
    return project.likes.findIndex((x) => x._id === me?._id) !== -1;
  }, [project, me]);

  const handleLike = () => {
    isLiked ? dislike(project._id) : like(project._id);
  };

  return (
    <Button onClick={handleLike} className={clsx(styles.upvote)} color="upvote">
      <svg
        width="12"
        height="9"
        viewBox="0 0 12 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 0L11.1962 9H0.803848L6 0Z" fill="white" />
      </svg>
      UPVOTE
      {project.likes && project.likes.length > 0 && (
        <span className={styles.likeCount}>&nbsp;{project.likes.length}</span>
      )}
    </Button>
  );
};

export default memo(UpvoteButton);
